import CloudKit from 'tsl-apple-cloudkit'
import { container } from '../CloudKitClient'
import { trackEvent, trackError } from '../analytics'

export function setUpAuth(
  onSuccess: (result: CloudKit.UserIdentity | null) => unknown,
  onError: (reason?: CloudKit.CKError) => unknown
) {
  if (!container) {
    // onError(new CloudKit.CKError())
    return
  }

  container
    .setUpAuth()
    .then(onSuccess)
    .catch((error: unknown) => onError(error as CloudKit.CKError))
}

export function onSignedIn(
  onSuccess: (result: CloudKit.UserIdentity) => unknown
) {
  if (!container) {
    return
  }
  container
    .whenUserSignsIn()
    .then(onSuccess)
    .catch((error: unknown) => {
      trackError('web.CloudKitClient.onSignedIn', 'Error during sign-in', {
        error: error instanceof Error ? error.message : String(error),
      })
    })
}

export function onSignedOut(onSuccess: () => unknown) {
  if (!container) {
    return
  }
  container
    .whenUserSignsOut()
    .then(onSuccess)
    .catch((error: unknown) => {
      console.error('Error during sign-out:', error)
      if (
        error instanceof Error &&
        error.message.includes('Auth session missing!')
      ) {
        onSuccess()
        return
      }
      trackEvent('web.CloudKitClient.onSignedOut', {
        error,
      })
    })
}
